import { IconPathData, IconProp } from '@fortawesome/fontawesome-svg-core';

export enum IconType {
    barcode = 'barcode',
    carrier = 'carrier',
    circleX = 'circleX',
    clone = 'clone',
    close = 'close',
    collapse = 'collapse',
    collapseAll = 'collapseAll',
    collapseTree = 'collapseTree',
    contact = 'contact',
    copy = 'copy',
    drag = 'drag',
    edit = 'edit',
    email = 'email',
    error = 'error',
    expand = 'expand',
    expandAll = 'expandAll',
    expandTree = 'expandTree',
    export = 'export',
    firebend = 'firebend',
    filter = 'filter',
    hide = 'hide',
    home = 'home',
    info = 'info',
    inlineMenu = 'inlineMenu',
    item = 'item',
    list = 'list',
    load = 'load',
    location = 'location',
    manage = 'manage',
    menu = 'menu',
    moneyCheck = 'moneyCheck',
    notification = 'notification',
    phone = 'phone',
    play = 'play',
    plus = 'plus',
    question = 'question',
    refresh = 'refresh',
    reporting = 'reporting',
    route = 'route',
    search = 'search',
    success = 'success',
    transportation = 'transportation',
    undo = 'undo',
    upload = 'upload',
    user = 'user',
    view = 'view',
    warning = 'warning',
}

export interface IconProps {
    faIcon: IconProp;
    height: number;
    width: number;
    pathData: IconPathData;
    style?: string;
}
